import styled from '@emotion/styled';
import { Button } from '@mui/material';

const StyledButton = styled(Button, { shouldForwardProp: propName => propName !== 'backgroundColor' })<{ backgroundColor?: string }>`
    border-radius: 8px;
    text-transform: none;
    background-color: ${({ backgroundColor }) => backgroundColor};
    align-items: center;
    padding: 10px 24px;
    margin-block-start: 24px;

    &.MuiButtonBase-root {
        color: #fff;
    }
    &.MuiButtonBase-root:hover {
        background-color: ${({ backgroundColor }) => backgroundColor};
    }
`;

interface Props {
    enabled: boolean;
    text?: string;
    url?: string;
    backgroundColor?: string;
    onClick: () => void;
}
export const CtaButton = ({ enabled, text, url, backgroundColor, onClick }: Props) => {
    if (!enabled || !text || !url) {
        return null;
    }

    const handleClick = () => {
        onClick();
        window.open(url, '_blank');
    };

    return (
        <StyledButton variant="contained" onClick={handleClick} backgroundColor={backgroundColor}>
            {text}
        </StyledButton>
    );
};
